module.exports = __webpack_public_path__ + "static/Corona-Banner-MB-undermaintenance-Mobile.ceb70c62.png";